import { createFileRoute } from "@tanstack/react-router";
import { Tasks } from "@/components/Tasks";

function RouteComponent() {
  return <Tasks />;
}

export const Route = createFileRoute("/_authenticated/tasks/")({
  component: RouteComponent,
  staticData: { page: "operations" },
});
